import { validationRules } from "./constants";

const formValidation = {
  firstName: {
    required: "Please enter first name.",
    pattern: {
      value: /^[^\s].*/,
      message: "Cannot start with a space.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  adminName: {
    required: "Please enter admin name.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    maxLength: {
      value: 15,
      message: "Maximum length should be 15 digits.",
    },
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage,
    },
  },
  lastName: {
    required: "Please enter last name.",
    pattern: {
      value: /^[^\s].*/,
      message: "Cannot start with a space.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  email: {
    required: "Please enter email ID.",
    pattern: {
      value: validationRules.email,
      message: "Please enter valid email ID as: example@domain.com.",
    },
  },
  subscriptionName: {
    required: "Please enter subscription name.",
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage,
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  subAdminName: {
    required: "Please enter subadmin name.",
    pattern: {
      value: /^[^\s].*/,
      message: "Cannot start with a space.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  name: {
    required: "Please enter company name.",
    pattern: {
      value: /^[^\s].*/,
      message: "Cannot start with a space.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  categoryName: {
    required: "Please enter category name.",
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage,
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    maxLength: {
      value: 50,
      message: "Maximum 50 characters are allowed.",
    },
  },
  mobile: {
    required: "Please enter mobile number.",
    minLength: {
      value: 8,
      message: "Minimum length should be 8 digits.",
    },
    maxLength: {
      value: 15,
      message: "Maximum length should be 15 digits.",
    },
    pattern: {
      value: /^(?:[1-9]\d*|0)$/,
      message: "First character can not be 0.",
    },
  },
  alternateEmail: {
    required: "Please enter alternate email ID.",
    pattern: {
      value: validationRules.email,
      message: "Please enter valid alternate email ID as: example@domain.com.",
    },
  },
  description: {
    required: "Please enter description.",
    minLength: {
      value: 10,
      message: "Description should contains at least 10 characters.",
    },
    maxLength: {
      value: 300,
      message: "Description should not exceed 300 characters.",
    },
  },
  title: {
    required: "Please enter title.",
    minLength: {
      value: 2,
      message: "Title should contains at least 2 characters.",
    },
    maxLength: {
      value: 255,
      message: "Title should not exceed 255 characters.",
    },
  },
  HRName: {
    required: "Please enter HR name.",
    pattern: {
      value: /^[^\s].*/,
      message: "Cannot start with a space.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },

  address: {
    required: "Please enter address.",
    validate: (value) => {
      const words = value.trim().split(" ");

      if (words.length <= 2) {
        return "Address should contain exactly 3 words.";
      } else if (words.length > 299) {
        return "Address should not exceed 300 words.";
      }
      return null;
    },
  },

  accountantName: {
    required: "Please enter accountant name.",
    pattern: {
      value: /^[^\s].*/,
      message: "Cannot start with a space.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  companyName: {
    required: "Please enter company name.",
    pattern: {
      value: /^[^\s].*/,
      message: "Cannot start with a space.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  jobTitle: {
    required: "Please enter job title.",
    pattern: {
      value: /^[^\s].*/,
      message: "Cannot start with a space.",
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  jobDescription: {
    required: "Please enter job description.",
    minLength: {
      value: 10,
      message: "Job description should contains at least 10 characters.",
    },
    maxLength: {
      value: 200,
      message: "Job description should not exceed 200 characters.",
    },
  },
  terminationCondition: {
    required: "Please enter termination condition.",
    minLength: {
      value: 10,
      message: "Termination condition should contains at least 10 characters.",
    },
    maxLength: {
      value: 200,
      message: "Termination condition should not exceed 200 characters.",
    },
  },
  countryName: {
    required: "Please enter country name.",
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage,
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
   stateName: {
    required: "Please enter state name.",
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage,
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
    zipcodeName: {
    required: "Please enter zip code.",
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage,
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  countryCode: {
    required: "Please enter country code.",
    min: {
      value: 1,
      message: "Minimum value must is 1.",
    },
  },
  cityName: {
    required: "Please enter city name.",
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage,
    },
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
  },
  comment: {
    required: "Please enter comment.",
    validate: (value) => {
      const words = value.trim().split(" ");
      if (words.length <= 9) {
        return "Comment should contains at least 10 words.";
      } else if (words.length > 799) {
        return "Comment should not exceed 800 words.";
      }
      return null;
    },
  },
  allowedHrs: {
    required: "Please enter allowed minutes.",
    minLength: {
      value: 1,
      message: "Minimum length should be 1 digits.",
    },
    min: {
      value: 1,
      message: "Minimum value must is 1.",
    },
    maxLength: {
      value: 3,
      message: "Maximum length should be 3 digits.",
    },
  },
  amount: {
    required: {
      value: true,
      message: "Please enter amount.",
    },
    maxLength: {
      value: 10,
      message: "Maximum limit is 10 characters.",
    },
    pattern: {
      value: true,
      message: "Only digits are allowed.",
    },
    min: {
      value: 1,
      message: "Minimum value must is 1.",
    },
  },
  duration: {
    required: {
      value: true,
      message: "Please enter duration.",
    },
    pattern: {
      value: true,
      message: "Only digits are allowed.",
    },
    max: {
      value: 1095,
      message: "Maximum limit is 1095 days.",
    },
    min: {
      value: 15,
      message: "Minimum value must is 15.",
    },
  },
  noOfEmployee: {
    required: {
      value: true,
      message: "Please enter number of employees.",
    },
    maxLength: {
      value: 10,
      message: "Maximum limit is 10 characters.",
    },
    pattern: {
      value: true,
      message: "Only digits are allowed.",
    },
    min: {
      value: 1,
      message: "Minimum value must is 1.",
    },
  },
  noOfHR: {
    required: {
      value: true,
      message: "Please enter number of HR.",
    },
    maxLength: {
      value: 10,
      message: "Maximum limit is 10 characters.",
    },
    pattern: {
      value: true,
      message: "Only digits are allowed.",
    },
    min: {
      value: 1,
      message: "Minimum value must is 1.",
    },
  },
  noOfAccountant: {
    required: {
      value: true,
      message: "Please enter number of accountant.",
    },
    maxLength: {
      value: 10,
      message: "Maximum limit is 10 characters.",
    },
    pattern: {
      value: true,
      message: "Only digits are allowed.",
    },
    min: {
      value: 1,
      message: "Minimum value must is 1.",
    },
  },
  subCategoryName: {
    required: "Please enter subcategory name.",
    minLength: {
      value: 2,
      message: "Minimum length must be 2.",
    },
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage,
    },
  },
  documentName: {
    required: 'Please enter document name',
    minLength: {
      value: 3,
      message: 'Document name must be at least 3 characters'
    },
    maxLength: {
      value: 100,
      message: 'Document name cannot exceed 100 characters'
    }
  },
  metaDescription: {},
  keyword: {},
};

export default formValidation;
